import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { ANALYTICS_HELPER } from '../utils'
import routes from '../route'

function usePageViews() {
	let location = useLocation()
	useEffect(() => {
		let path = routes.find((route) => {
			return route.path === location?.pathname
		})
		if (path !== -1 && path !== undefined) {
			ANALYTICS_HELPER._setPageView(path.view)
		} else {
			ANALYTICS_HELPER._setPageView(window.location.pathname)
		}
	}, [location])
}
export default usePageViews
